import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false); // ✅ Sidebar state

  const handleClick = (destination) => {
    navigate(destination);
    setIsOpen(false); // close sidebar when navigating
  };

  return (
    <header className="bg-white relative z-50">
      <div className="mx-auto max-w-full px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <div className="md:flex md:items-center md:gap-12">
            <a className="block text-black" href="/">
              <span className="sr-only">PrepNexis</span>
              <div className="w-[140px] h-auto">
                <img
                  src="/image/prep2.png"
                  alt="PrepNexis Logo"
                  className="object-contain w-full h-auto"
                />
              </div>
            </a>
          </div>

          {/* Desktop nav */}
          <div className="hidden md:block">
            <nav aria-label="Global">
              <ul className="flex items-center gap-6 text-sm">
                <li>
                  <a
                    className="text-gray-500 hover:text-gray-800"
                    href="/blog/about-us"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    className="text-gray-500 hover:text-gray-800"
                    href="/pricing"
                  >
                    Pricing
                  </a>
                </li>
                <li>
                  <a
                    className="text-gray-500 hover:text-gray-800"
                    href="/blog/our-services"
                  >
                    Services
                  </a>
                </li>
                {/* <li>
                  <a
                    className="text-gray-500 hover:text-gray-800"
                    href="/Courses"
                  >
                    Courses
                  </a>
                </li> */}
                <li>
                  <a className="text-gray-500 hover:text-gray-800" href="/blog">
                    Blog
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Buttons + Mobile toggle */}
          <div className="flex items-center gap-4">
            <div className="sm:flex sm:gap-4">
              <button
                onClick={() => handleClick("/login")}
                className="rounded-sm bg-gray-800 px-5 py-2.5 text-sm font-medium text-white shadow"
              >
                Login
              </button>

              <div className="hidden sm:flex">
                <button
                  onClick={() => handleClick("/signup")}
                  className="rounded-sm bg-gray-100 px-5 py-2.5 text-sm font-medium text-black"
                >
                  Register
                </button>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="block md:hidden">
              <button
                onClick={() => setIsOpen(true)}
                className="rounded bg-gray-100 p-2 text-gray-600 hover:text-gray-800"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Sidebar Menu */}
      <div
        className={`fixed inset-0 z-50 transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Overlay */}
        <div
          className={`fixed inset-0 bg-black bg-opacity-40 transition-opacity duration-300 ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          onClick={() => setIsOpen(false)}
        ></div>

        {/* Sidebar content */}
        <div className="fixed right-0 top-0 h-full w-96 bg-white shadow-lg p-6 flex flex-col">
          {/* Close button */}
          <button
            onClick={() => setIsOpen(false)}
            className="self-end mb-6 text-gray-600 hover:text-black"
          >
            ✕
          </button>

          <nav className="flex flex-col space-y-4 text-gray-700">
            <a
              onClick={() => handleClick("/blog/about-us")}
              className="hover:text-black cursor-pointer"
            >
              About
            </a>
            <a
              onClick={() => handleClick("/pricing")}
              className="hover:text-black cursor-pointer"
            >
              Pricing
            </a>
            <a
              onClick={() => handleClick("/blog/our-services")}
              className="hover:text-black cursor-pointer"
            >
              Services
            </a>
            <a
              onClick={() => handleClick("/Courses")}
              className="hover:text-black cursor-pointer"
            >
              Courses
            </a>
            <a
              onClick={() => handleClick("/blog")}
              className="hover:text-black cursor-pointer"
            >
              Blog
            </a>
          </nav>

          <div className="mt-8 flex flex-col space-y-3">
            <button
              onClick={() => handleClick("/login")}
              className="rounded bg-gray-800 px-4 py-2 text-white"
            >
              Login
            </button>
            <button
              onClick={() => handleClick("/signup")}
              className="rounded bg-gray-200 px-4 py-2 text-black"
            >
              Register
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
